export default "assets/images/icons/entity-soil-f6da4c32.svg";